import { CR } from "./jkInterface";


export enum validType {
    'invalid',
    'required',
    'minLength',
    'maxLength',
    'pattern',
    'min',
    'max',
    'email',
    'date',
    'time',
    'dateTime',
    'number',
    'url',
    'unique',
    'custom'
}

export enum entityState {
    dsBrowse,
    dsInsert,
    dsEdit,
    dsDelete,
    dsUpdate,
    dsDeleteAll,
    dsInsertAll,
    dsUpdateAll,
    dsFilte,
}

export function entityStateName(st: entityState): string {
    let result = '';
    switch (st) {
        case entityState.dsBrowse:
            result = '瀏覽';
            break;
        case entityState.dsInsert:
            result = '新增';
            break;
        case entityState.dsEdit:
            result = '修改';
            break;
        case entityState.dsDelete:
            result = '刪除';
            break;
    }
    return result;
}

export enum EntityType {
    data,
    master,
    detail,
    body,
    foot,
    log,
}

export class validArgs {
    fieldName: string = '';
    type: validType = validType.invalid;
    message: string = '';
    constructor(fieldName: string, message: string, type = validType.invalid) {
        this.fieldName = fieldName;
        this.message = message;
        this.type = type;
    }
}
export class validateClass {
    invalidList: validArgs[] = [];
    isAllValid(): boolean {
        return this.invalidList.length === 0;
    }
    valid(bool: boolean, fieldName: string, type: validType, message: string): void {
        let n = this.invalidList.findIndex(v => { return (v.fieldName === fieldName) && (v.type === type) });
        if (bool) {// valid true, remove from invalidList
            if (n >= 0) {
                this.invalidList.splice(n, 1);
            }
        } else {// valid false, add to invalidList
            if (n < 0) {
                let v = new validArgs(fieldName, message, type);
                this.invalidList.push(v);
            }
        }
    }
    state(state: entityState) {
        this.invalidList = [];
    }
    AllMessage(): string {
        let s = '';
        this.invalidList.forEach((v) => {
            s = s + v.message + CR;
        });
        return s;
    }
}

export class loadBodyOption {
    isSys: boolean = false;
    key: any; // keyfields
    keyValues: any;
    method: string = 'post'; // get | post
    sql: string = '';
    tableName: string = '';
    values: any;
    where: string = '';
}


export class ManagerField {
    COMPANY = '';
    CREATOR = '';
    USR_GROUP = '';
    CREATE_DATE = '';
    MODIFIER = '';
    MODI_DATE = '';
    FLAG = 1;
    constructor() { }
    ManagerField() {
        this.clear();
    }
    public clear() {
        this.FLAG = 1;
        this.COMPANY = '';
        this.CREATOR = '';
        this.USR_GROUP = '';
        this.CREATE_DATE = '';
        this.MODIFIER = '';
        this.MODI_DATE = '';
        // Attribute.GetCustomAttribute(this,"string"). = "";
    }
}


export class JkEntityType {
    /** table種類: master:單頭 detail:單身 foot:子單身 data:基本資料 */
    //public kind = 'data'; // master,detail,foot,data,
    public type: EntityType = EntityType.data; // data,master,detail,log
    public billTypeFN = ''; // 單別欄位名稱
    public billType = ''; // 單別
    public billNoFN = ''; // 單號欄位名稱
    public billNo = ''; // 單號
    public billItemNoFN = ''; // 序號欄位名稱
    billItemNo = ''; // 序號
    public billFootNoFN = ''; // 單別欄位名稱
    billFootNo = ''; // 子序號
    billDateFieldName = ''; // 單據日期欄位名稱
    confirmDateFieldName = ''; // 確認日
    setBillData(item: any): void {
        //this.fieldNames = xFieldNames;
        /*
        const ary = xFieldNames.split(',');
        for (let i = 0; i < ary.length; i++) {
          //
          [ary[i].trim()] = ko.observable();
          // debugger; // 19.1 remove
        };*/
        if (this.type === EntityType.master) {
            this.billType = item[this.billTypeFN];
            this.billNo = item[this.billNoFN];
        }
        if (this.type === EntityType.detail) {
            this.billType = item[this.billTypeFN];
            this.billNo = item[this.billNo];
            this.billItemNo = item[this.billItemNo];
        }
        if (this.type === EntityType.foot) {
            this.billType = item[this.billTypeFN];
            this.billNo = item[this.billNo];
            this.billItemNo = item[this.billItemNoFN];
            this.billFootNo = item[this.billFootNoFN];
        }
        if (this.type === EntityType.data) {
        }
    }
}

